import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SearchSelect } from '../shared/searchSelect';
import Enums from '../../utilities/enum';
import arrayUtilities from '../../utilities/arrayUtilities';
import stringHelpers from '../../utilities/stringHelpers';
import api from '../api/api';
import { SuccessModal } from '../shared/successModal';
import { ErrorModal } from '../../utilities/errorModal';
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Loader from '../shared/loader';
import { WarningModal } from '../shared/warningModal';
import Pagination from '../shared/pagination';
import { SearchBarWithDebounce } from '../shared/searchBarWithDebounce';
import { FiltersModalTrigger } from '../shared/filtersModalTrigger';
import { AppliedFilterDisplay } from '../shared/appliedFilterDisplay';
import { AllocateBreachesFormFiltersModal } from './allocateBreachesFormFiltersModal';

export const AllocateBreachesForm = ({ organisationId, token, users, clients, sites }) => {
    const allocationStatuses = [
        {id: "0", status: 0}, 
        {id: "200",status: 200}, 
        {id: "210", status: 210}
    ]
    const location = useLocation()
    const isAssigned = location && location.state !== undefined && location.state.isAssigned !== undefined ? location.state.isAssigned : null
    const [selectedUser, setSelectedUser] = useState("")
    const [searchQuery, setSearchQuery] = useState("")
    const [selectedStatuses, setSelectedStatuses] = useState([])
    const [selectedSites, setSelectedSites] = useState([]);
    const [isSelectAllStatusChecked, setIsSelectAllStatusChecked] = useState(false)
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false)
    const [isLoadingSites, setIsLoadingSites] = useState(false)
    const [isAllocating, setIsAllocating] = useState(false)
    const [selectedClient, setSelectedClient] = useState("");
    const [sitesByClient, setSitesByClient] = useState(sites)
    const [canSave, setCanSave] = useState(false)
    const [successMessage, setSuccessMessage] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)
    const [warningMessage, setWarningMessage] = useState(null)
    const [sitesPageNumber, setSitesPageNumber] = useState(0);
    const [showSitesFiltersModal, setShowSitesFiltersModal] = useState(false)
    const [showSitesFilterPills, setShowSitesFilterPills] = useState(false)
    const [sitesAppliedFilters, setSitesAppliedFilters] = useState(null)
    const [receivedDaysAgo, setReceivedDaysAgo] = useState(1)
    var _sitesAbortController = null;

    const getSites = (query, clientId, page) => {
        setIsLoadingSites(true)
        if (_sitesAbortController) {
            _sitesAbortController.abort();
        }
        _sitesAbortController = new AbortController();
        const signal = _sitesAbortController.signal;
        api.searchSites(
            (data) => {
                setSitesByClient(data.items);
                setIsLoadingSites(false)
            },
            (error) => {
                console.log(error)
                setSitesByClient([]);
                setIsLoadingSites(false)
            },
            query,
            page,
            !stringHelpers.isNullOrEmpty(clientId) ? clientId : null,
            null,
            null,
            null,
            organisationId,
            token,
            signal
        );
    };

    useEffect(() => {
        getSites("", null, 0)
    }, [])

    useEffect(() => {
        const hasAppealStatusSelected = selectedStatuses.includes("200") || selectedStatuses.includes("210")
        const hasNewStatusSelected = selectedStatuses.includes("0")
        const isSiteRequired = hasNewStatusSelected || !hasAppealStatusSelected
        setCanSave(!arrayUtilities.isNullOrEmpty(selectedStatuses)
            && !stringHelpers.isNullOrEmpty(selectedUser)
            && (!isSiteRequired || !arrayUtilities.isNullOrEmpty(selectedSites))
            && (!hasAppealStatusSelected || receivedDaysAgo > 0)
        )
    }, [selectedUser, selectedStatuses, selectedSites, receivedDaysAgo])

    const allocateTickets = () => {
        setIsAllocating(true)
        const hasAppealStatusSelected = selectedStatuses.includes("200") || selectedStatuses.includes("210")
        const siteIdsToSearch = !arrayUtilities.isNullOrEmpty(selectedSites) ? selectedSites : null
        const receivedDaysAgoToSearch = hasAppealStatusSelected ? receivedDaysAgo : null
        const controller = new AbortController();
        api.getBreaches(
            data => {
                if (data.totalCount === 0 && !stringHelpers.isNullOrEmpty(selectedUser)) {
                    setWarningMessage('No breaches found to allocate for the selected sites');
                    setIsAllocating(false)
                }
                else {
                    const idsToAllocate = data.items.map(breach => breach.id)            
                    api.assignTickets(
                        result => {
                            if (result.isError) {
                                setErrorMessage(result.errorMessage)
                                setIsAllocating(false)
                            } else {
                                setSuccessMessage(`Successfully allocated ${ result.length } tickets`);
                                setIsAllocating(false)
                            }
                        },
                        (error) => {
                            console.log(error)
                            setErrorMessage(error.message)
                            setIsAllocating(false)
                        },
                        selectedUser,
                        idsToAllocate,
                        organisationId,
                        token
                    )
                }
            },
            (error) => {
                console.log(error)
                setErrorMessage(error.message)
                setIsAllocating(false)
            },
            null, siteIdsToSearch, null,
            isAssigned,
            null, null, null, selectedStatuses.map(item => Number(item)), null, 0, 0, null, null, null,
            receivedDaysAgoToSearch, receivedDaysAgoToSearch,
            null,
            organisationId,
            token,
            controller.signal
        )
        
        setSelectedClient(null);
        setSelectedStatuses([])
        setSelectedSites([])
        setSitesAppliedFilters(null)
        setReceivedDaysAgo(1)
        getSites("", null, 0);
        setIsSelectAllStatusChecked(false)
        setIsSelectAllChecked(false)
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="row align-items-center">
                                <div className="col color-code-row">
                                    <h5 className="mb-0">{ isAssigned === null ? 'Re-Allocate breaches' : 'Allocate breaches' }</h5>
                                </div>
                                <Link className="btn btn-falcon-default btn-sm mr-3 py-1" type="button" to={ `/organisation/${ organisationId }/breaches` }><i className="fas fa-reply"></i> Back</Link>
                            </div>
                        </div>
                    </div>

                    {
                        <div className="card mb-3 details-container">
                            {isAllocating ? <Loader />
                            : <div className="card-header">
                                <div className="row mb-3">
                                    <div className="col-12 ">
                                        <h5 className="text-danger font-weight-semi-bold">Important:</h5>
                                        <p className="font-weight-bold mt-1 mb-1">This will allocate the next 100 tickets currently not allocated to any user for the selected site{
                                            location && location.state !== undefined && location.state.isAssigned !== undefined && location.state.isAssigned === null && <>, including tickets already allocated to a user.</>
                                        }</p>
                                    </div>
                                </div>
                                <div className="row align-items-center mb-3">
                                    <div className=" col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold mt-1 mb-1">User<span className="req"></span></p>
                                    </div>
                                    { users && <div className="px-0 col-md-6 col-12">
                                        <SearchSelect
                                            width="100%"
                                            options={
                                                [

                                                    ...users
                                                        .map(item => ({ value: item.id, label: `${ item.firstName } ${ item.lastName }` }))
                                                ]
                                            }
                                            onSelect={ value => setSelectedUser(value) }
                                            selected={ selectedUser }
                                            defaultLabel="Select a user"
                                        />
                                    </div> }
                                </div>
                                <hr className="border-dashed border-bottom-0"></hr>

                                <div className="row mb-3">
                                    <div className=" col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Status<span className="req"></span></p>
                                    </div>
                                    <div className="col-md-6 col-12 px-0" id="status-list" aria-labelledby="Status List" data-parent="#statuses">
                                        <div className="form-group mb-0">
                                            <div className="custom-control custom-checkbox checkbox-list-item">
                                                <input className="custom-control-input" type="checkbox" checked={ isSelectAllStatusChecked } id="status-all" onChange={ e => arrayUtilities.handleSelectAll(e, isSelectAllStatusChecked, setIsSelectAllStatusChecked, () => setSelectedStatuses([]), () => setSelectedStatuses(allocationStatuses.map(e => e.id))) } />
                                                <label className="custom-control-label" htmlFor="status-all">All</label>
                                            </div>
                                        </div>
                                        {
                                            allocationStatuses.map(
                                                item => (
                                                    <div className="form-group mb-0">
                                                        <div className="custom-control custom-checkbox checkbox-list-item">
                                                            <input className="custom-control-input" type="checkbox" checked={ selectedStatuses.includes(item.id) } id={`status-${Enums.BreachStatus[item.status]}`} onChange={ event => arrayUtilities.handleListSelection(event.target.checked, item, setSelectedStatuses, selectedStatuses, allocationStatuses, isSelectAllStatusChecked, setIsSelectAllStatusChecked)} />
                                                            <label className="custom-control-label" htmlFor={`status-${Enums.BreachStatus[item.status]}`}>{ Enums.BreachStatus[item.status] }</label>
                                                        </div>
                                                    </div>
                                                )
                                            )
                                        }
                                    </div>
                                </div>
                                <hr className="border-dashed border-bottom-0"></hr>
                                <div className="row mb-3">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Site{selectedStatuses.includes("0") && <span className="req"></span>}</p>
                                    </div>
                                    { sites && <div className='px-0 col-md-6 col-12'>
                                        <div className="d-flex align-items-center mb-2">
                                            <SearchBarWithDebounce onSearchQueryChange={ query => {
                                                setSearchQuery(query)
                                                setSitesPageNumber(0)
                                                getSites(query, selectedClient, 0)
                                            } } />
                                            <div className='ml-2'>
                                                <FiltersModalTrigger onClick={ () => setShowSitesFiltersModal(true) } />
                                            </div>
                                        </div>
                                        {
                                            showSitesFilterPills && sitesAppliedFilters &&
                                            <div className="d-flex align-items-center flex-wrap mb-2">
                                                {
                                                    Object.entries(sitesAppliedFilters).map(
                                                        ([label, value]) => !stringHelpers.isNullOrEmpty(value)
                                                        && <div className="mr-2" key={ label }>
                                                            <AppliedFilterDisplay
                                                                label={ label }
                                                                onTextClick={ () => setShowSitesFiltersModal(true) }
                                                                onCloseClick={ closedLabel => {
                                                                    setSelectedClient("")
                                                                    setSitesPageNumber(0)
                                                                    getSites(searchQuery, "", 0)
                                                                    setSitesAppliedFilters(prevState => {
                                                                        const updatedFilters = { ...prevState }
                                                                        updatedFilters[closedLabel] = null
                                                                        const hasRemainingFilters = Object.values(updatedFilters).some(value => !stringHelpers.isNullOrEmpty(value))
                                                                        return hasRemainingFilters ? updatedFilters : null
                                                                    })
                                                                } }
                                                                value={ value }
                                                            />
                                                        </div>
                                                    )
                                                }
                                                { Object.keys(sitesAppliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={ () => {
                                                    setSelectedClient("")
                                                    setSitesPageNumber(0)
                                                    setSitesAppliedFilters(null)
                                                    getSites(searchQuery, "", 0)
                                                } }>Clear all filters</button> }
                                            </div>
                                        }

                                        <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table w-100 border-bottom border-200 no-footer ">
                                            <thead className="bg-200 text-900">
                                                <tr>
                                                    <td>
                                                        <input className="" type="checkbox" checked={ isSelectAllChecked } id="select-all-sites" onChange={ 
                                                            event => arrayUtilities.handleSelectAll(event, isSelectAllChecked, setIsSelectAllChecked, () => setSelectedSites([]), () => setSelectedSites(sitesByClient.map(item => item.id))) } />
                                                    </td>
                                                    <th>Client</th>
                                                    <th>Name</th>
                                                    <th>Code</th>
                                                    <th className="text-center">Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    isLoadingSites ? <tr><td className='text-center' colSpan={ 5 }><Loader /></td></tr>
                                                        : !arrayUtilities.isNullOrEmpty(sitesByClient)
                                                        && sitesByClient.map(
                                                            site => <tr key={ site.id }>
                                                                <td><input className="" type="checkbox" checked={ selectedSites.includes(site.id) } id={ `select-site-${ site.id }` } 
                                                                onChange={ event => arrayUtilities.handleListSelection(event.target.checked, site, setSelectedSites, selectedSites, sitesByClient, isSelectAllChecked, setIsSelectAllChecked) } /></td>
                                                                <td>{ site.clientName }</td>
                                                                <td><Link to={ `/organisation/${ organisationId }/client/${ site.clientId }/site/${ site.id }` }><h6 className="mb-0">{ site.name }</h6></Link></td>
                                                                <td>{ site.siteCode }</td>
                                                                <td className="text-center">{ site.isActive && <><i className="fas fa-check text-success"></i></> }{ !site.isActive && <><i className="fas fa-times text-danger"></i></> }</td>
                                                            </tr>
                                                        )
                                                }
                                            </tbody>
                                        </table>
                                        <div className="d-flex justify-content-center row align-items-center pt-2">
                                            <div className="col-auto align-items-center">
                                                <Pagination
                                                    totalResults={sitesByClient?.length}
                                                    currentPage={sitesPageNumber}
                                                    changePageNumber={number => {
                                                        getSites(searchQuery, selectedClient, number)
                                                        setSitesPageNumber(number)
                                                    }} />
                                            </div>
                                        </div>

                                    </div> }
                                </div>
                                {
                                    (selectedStatuses.includes("200") || selectedStatuses.includes("210"))
                                    && <>
                                        <hr className="border-dashed border-bottom-0"></hr>
                                        <div className="row mb-3">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold">Time since appeal/transfer of liability received<span className="req"></span></p>
                                            </div>
                                            <div className="px-0 col-md-6 col-12">
                                                <div className="d-flex align-items-center mb-1">
                                                    <div className="d-flex align-items-center">
                                                        <span className="">{ receivedDaysAgo } {stringHelpers.pluralSuffixModifier(receivedDaysAgo, "days") }</span>
                                                    </div>
                                                </div>
                                                <div className='d-flex align-items-center justify-content-evenly w-100'>
                                                    <button onClick={ () => {
                                                        if (receivedDaysAgo > 1) {
                                                            setReceivedDaysAgo(prevState => prevState - 1)
                                                        }
                                                    } } type='button' className='btn btn-none p-0 m-0 mr-2'>
                                                        <i className='fas fa-minus'></i>
                                                    </button>
                                                    <div className='w-100'>
                                                        <input
                                                            list="markers"
                                                            className="w-100"
                                                            id="received-days-ago"
                                                            type="range"
                                                            min={ 1 }
                                                            max={ 28 }
                                                            step={ 1 }
                                                            value={ receivedDaysAgo }
                                                            onChange={ event => setReceivedDaysAgo(Number(event.target.value)) }
                                                        />
                                                        <datalist id="markers">
                                                            {
                                                                Array.from({ length: 29 }, (_, i) => i++)
                                                                    .map(
                                                                        marker => <option className='p-0' value={ marker }></option>
                                                                    )
                                                            }
                                                        </datalist>
                                                    </div>
                                                    <button onClick={ () => {
                                                        if (receivedDaysAgo < 28) {
                                                            setReceivedDaysAgo(prevState => prevState + 1)
                                                        }
                                                    } } type='button' className='btn btn-none p-0 m-0 ml-2'>
                                                        <i className='fas fa-plus'></i>
                                                    </button>
                                                </div>
                                                <div className='d-flex justify-content-between px-3'>
                                                    <label className='ml-3'>1</label>
                                                    <label className='mr-2'>28</label>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>}
                            <div className="card-footer border-top ">
                                <div className="row client-edit-buttons">
                                    <div className="col-6 col-sm-auto ml-auto  pl-0">
                                        <div id="dashboard-actions">
                                            <Link to={ `/organisation/${ organisationId }/breaches` }>
                                                <button type="button" className="btn btn-falcon-default btn-sm ml-2">
                                                    <i className="fas fa-times"></i> Cancel</button>
                                            </Link>
                                            <button type="button" className="btn btn-success btn-sm ml-2" disabled={ !canSave } onClick={ () => allocateTickets() }>
                                                <i className="fas fa-check"></i> Confirm</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
            {
                !stringHelpers.isNullOrEmpty(successMessage) &&
                <SuccessModal
                    message={ successMessage }
                    onHide={ () => setSuccessMessage(null) }
                />
            }
            {
                !stringHelpers.isNullOrEmpty(errorMessage) &&
                <ErrorModal
                    message={ errorMessage }
                    onHide={ () => setErrorMessage(null) }
                />
            }
            {
                !stringHelpers.isNullOrEmpty(warningMessage) &&
                <WarningModal
                    message={ warningMessage }
                    onHide={ () => setWarningMessage(null) }
                />
            }
            {
                showSitesFiltersModal &&
                <AllocateBreachesFormFiltersModal
                    showModal={ showSitesFiltersModal }
                    handleClose={ () => setShowSitesFiltersModal(false) }
                    handleConfirm={ (draftFilters) => {
                        setSelectedClient(draftFilters.selectedClient)
                        setSitesAppliedFilters(draftFilters.appliedFilters)
                        setShowSitesFilterPills(true)
                        setShowSitesFiltersModal(false)
                        setSitesPageNumber(0)
                        getSites(searchQuery, draftFilters.selectedClient, 0)
                    } }
                    initialSelectedClient={ selectedClient }
                    initialAppliedFilters={ sitesAppliedFilters }
                    clients={ clients }
                    key="allocate-breaches-form-filters-modal"
                />
            }
        </div>
    )
}